// @ts-nocheck
import { PREFERENCES_ERROR, PREFERENCES_LOADING, PREFERENCES_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const preferences = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: PREFERENCES_LOADING,
                data: true
            })
            Authservices.preferences(data).then((data) => {
                if (!data) {
                    dispatch({ type: PREFERENCES_ERROR, data: { message: 'Request failed. Please try again.' } })
                    return reject({ message: 'Request failed. Please try again.' });
                }
                if (data?.status === 200) {
                    dispatch({
                        type: PREFERENCES_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
                dispatch({ type: PREFERENCES_ERROR, data: { message: 'Unexpected response. Please try again.' } })
                return reject({ message: 'Unexpected response. Please try again.' });
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: PREFERENCES_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}